'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const SkipToContent = ({
  targetId,
  scrollToTarget
}) => {
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const {
    translations: {
      skipToContent
    },
    loading
  } = nthHookTranslations.useTranslationsX();
  if (!loading && !skipToContent) throw new Error('Translation key `skipToContent` has no value. Please add this translation');
  const preventScrollOnNavigate = e => {
    e.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      window.history.pushState(null, '', `#${targetId}`);
      targetElement.focus();
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    target: TextLink.TextLinkTargetType.SELF,
    linkStyle: {
      sDefault: {
        ...linksNoneDefault,
        padding: '0.5rem 1rem',
        background: '#fff',
        opacity: 0,
        position: 'absolute',
        zIndex: 100,
        // Because the div below this element has zIndex: 99,
        top: '-9999px',
        left: '-9999px',
        transition: 'opacity 0.3s ease-in-out'
      },
      sHover: {
        ...linksNoneHover,
        background: '#fff'
      },
      sFocus: {
        top: '1rem',
        left: '50%',
        transform: 'translate(-50%, 0)',
        opacity: 1
      }
    },
    href: `#${targetId}`,
    onClick: scrollToTarget ? undefined : preventScrollOnNavigate
  }, skipToContent);
};
var SkipToContent$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(SkipToContent, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['skipToContent']
});

exports["default"] = SkipToContent$1;
